export function ImgChevronDown({ size = 20 }: { size?: number }) {
  return (
    <svg className="plugin-card__chevron" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
      <polyline points="5 8 10 13 15 8" />
    </svg>
  );
}
